import _ from 'lodash';
import moment from 'moment';
import { createApp, defineComponent } from 'vue';
import GridDateCellEditor from './GridDateCellEditor.vue';
import dateFormatHelper from '$$dateFormatsHelper';
import globalToast from '$$vueCmp/toast';
import KeyboardNavigation from '../../keyboardNavigation';

export default function (instance) {
  let vueApp = null;
  let vueInstance = null;

  return {
    show(id, column, config, placeholder) {
      const ComponentBuilder = defineComponent(GridDateCellEditor);
      const task = instance.getTask(id);

      const calendar = instance.getCalendar(task.gantt_id);
      const calendarConfig = _.cloneDeep(calendar.getConfig());

      const workDays = instance.config.durationData.showDay;

      const minDate = column.name === 'end_date' ? task.start_date : null;
      let todayDate = null;

      if ((minDate ? minDate < new Date() : true) && instance.isWorkDay(new Date(), calendar)) {
        todayDate = column.name === 'end_date' ? instance.date.day_start(new Date(new Date().getTime() + 24 * 60 * 60 * 1000)) : instance.date.day_start(new Date());
      }

      const onSave = () => {
        instance.ext.inlineEditors.save();
      };
      const onCancel = () => {
        instance.ext.inlineEditors.hide();
      };

      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = createApp(ComponentBuilder, {
        placeholder,
        column,
        workDays,
        calendarConfig,
        minDate,
        todayDate,
        onSave,
        onCancel,
      });
      vueInstance = vueApp.mount(placeholder);

      KeyboardNavigation.toggleState(false);
    },

    hide() {
      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = null;
      vueInstance = null;

      KeyboardNavigation.toggleState(true);
    },

    set_value(task, id, column, node) {
      const value = task[column.name];

      if (value) {
        const date = new Date(value);
        const format = dateFormatHelper.getDateFormatForGanttGrid();

        vueInstance.value = instance.date.date_to_str(format.replace('%A', ' %A'))(date);
        vueInstance.datePickerValue = value;
      }
    },

    get_value(id, column, node) {
      return vueInstance.value;
    },

    is_changed(task, id, column, node) {
      const formater = dateFormatHelper.convertGanttDateFormat(true);
      let vueValue = vueInstance.value;

      if (_.isString(vueValue)) {
        vueValue = moment(vueValue.trim(), formater, 'en', true).toDate();
      }

      return task[column.name]?.valueOf() !== vueValue?.valueOf();
    },

    is_valid(value, id, column, node) {
      const formater = dateFormatHelper.convertGanttDateFormat(true);

      if (_.isString(value) && moment(value.trim(), formater, 'en', true).isValid()) {
        return true;
      }

      if (value && (value instanceof Date) && !_.isNaN(value.getTime())) {
        return true;
      }

      globalToast.warning(__('gantt_date_invalid'));

      return false;
    },

    save(id, column, node) {
      const task = instance.getTask(id);
      const calendar = instance.getCalendar(task.gantt_id);
      const formater = dateFormatHelper.convertGanttDateFormat(true);
      let value = vueInstance.value;

      if (_.isString(value)) {
        value = moment(value.trim(), formater, 'en', true).toDate();
      }

      value = dateFormatHelper.checkIfDateInLimit(value, false);

      if (value && value.getTime() && column.name === 'start_date') {
        let newValue = instance.date.minute_start(value);

        if (!instance.isWorkDay(newValue, calendar) || !instance.isWorkTime(newValue, 'minute', calendar)) {
          newValue = instance.getClosestWorkTime({
            date: newValue,
            dir: 'future',
            unit: instance.config.duration_unit,
            task,
          });
        }

        if (task.start_date.valueOf() !== newValue.valueOf()) {
          const oldDate = task.start_date;

          task.start_date = newValue;
          task.end_date = instance.calculateEndDate({
            start_date: task.start_date,
            duration: task.duration,
            unit: instance.config.duration_unit,
            task,
          });

          if (task.type === instance.config.types.project) {
            instance.moveProject(task.id, task.start_date, oldDate);
          }

          instance.updateTask(task.id);

          userExtAnalytics.log('task_grid_action', { action: 'start_date' });
        }
      }

      if (value && value.getTime() && column.name === 'end_date') {
        const newValue = instance.date.minute_start(value);

        if (task.end_date.valueOf() !== newValue.valueOf() && task.start_date.valueOf() < newValue.valueOf()) {
          task.duration = instance.calculateDuration({
            start_date: task.start_date,
            end_date: newValue,
            unit: instance.config.duration_unit,
            task,
          });
          task.end_date = instance.calculateEndDate({
            start_date: task.start_date,
            duration: task.duration,
            unit: instance.config.duration_unit,
            task,
          });

          instance.updateTask(task.id);

          userExtAnalytics.log('task_grid_action', { action: 'end_date' });
        }
      }
    },

    focus(node) {
    },
  };
}
